import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BomLibraryTagsInput from './bomLibraryTagsInput';
import * as configAction from '../store/BomLibrary.action';

function BomLibraryTagsModel({ toggle, onOpen, BOMId }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const TagsList = useSelector((state) => state.BomLibraryDetails.tagsListById);
  const [Tags, setTags] = useState(TagsList);
  useEffect(() => {
    setTags(TagsList);
  }, [TagsList]);

  const handletags = (tags) => {
    setTags(tags);
  };

  console.log(Tags, TagsList, 'this is  model intial array');
  const onSubmitMethod = (e) => {
    const tagsData = { tags: Tags, bomComponentId: BOMId };

    dispatch(configAction.addBomLibraryTagsAction(tagsData));
    dispatch(configAction.fetchBomLibraryTagsAction());

    toggle();
  };

  return (
    <Modal
      show={onOpen}
      backdrop="static"
      className="modal-medium common-custom-modal common-new-modal"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={toggle}
    >
      <Modal.Header className="position-relative">
        <Modal.Title id="contained-modal-title-vcenter">
          <span>{t('BOM_LIBRARY.BOM_LIBRARY_TAG.BOM_LIBRARY_TAG_MODAL.TAGS')}</span>
        </Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer ml-auto" />
      </Modal.Header>
      <Modal.Body>
        <div className="App modal-inner-data">
          <BomLibraryTagsInput tagsInputs={handletags} bomComponentId={BOMId} />
        </div>
        <div className="common-model-footer">
          <button type="button" aria-label="save" onClick={onSubmitMethod} className="btn p-0">
            <i className="icon-Tick-1 text-grey-color f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
export default BomLibraryTagsModel;
